import { DashboardColumns } from '@/interfaces/DashboardInterface/DashboardInterface';

export const resolveDashboardName = (column: DashboardColumns, asterisks = false) => {
  switch (column) {
    case DashboardColumns.STATUS:
      return 'Estado';
    case DashboardColumns.DNI_CIF:
      return 'DNI/CIF';
    case DashboardColumns.AG_CODE:
      return 'Código AG';
    case DashboardColumns.CUSTOMER:
      return 'Cliente';
    case DashboardColumns.DATE:
      return 'Fecha solicitud';
    case DashboardColumns.AMOUNT:
      return 'Importe';
    case DashboardColumns.EMAIL:
      return 'Email';
    case DashboardColumns.OFFER:
      return 'Tarifa';
    case DashboardColumns.PROPOSAL_TERM:
      return 'Plazo';
    case DashboardColumns.CART_ID:
      if (asterisks) {
        return 'Carrito **';
      }
      return 'Carrito';
    case DashboardColumns.PRODUCT:
      return 'Producto';
    case DashboardColumns.APPLICATION:
      return 'Aplicación';
    case DashboardColumns.PRODUCTS_NUM:
      if (asterisks) {
        return 'Nº productos **';
      }
      return 'Nº productos';
    case DashboardColumns.PROCESS_TYPE:
      if (asterisks) {
        return 'Tipo de proceso **';
      }
      return 'Tipo de proceso';
    default:
      return '';
  }
};

export const getDefaultDashboardColumns = () => [
  DashboardColumns.STATUS,
  DashboardColumns.DNI_CIF,
  DashboardColumns.AG_CODE,
  DashboardColumns.CUSTOMER,
  DashboardColumns.DATE,
  DashboardColumns.AMOUNT,
];
